export function fixSpaces(str) {
  if (str) {
    // Trim leading and trailing spaces
    str = str.trim();
    // Replace multiple spaces with a single space
    str = str.replace(/\s+/g, " ");
  } else {
    str = "";
  }
  return str;
}

export function abreviarNome(str) {
  if (!str) return "";
  // Remover espaços à esquerda/direita e ignorar tokens vazios (espaços a mais)
  const partes = str.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "";
  if (partes.length === 1) return partes[0];
  return partes[0] + " " + partes[partes.length - 1];
}
